/**
 * Font Size Constants
 * 
 * Centralized font size definitions for consistent typography across components.
 * Use these constants instead of hardcoded rem values in component styles.
 */

export const FONT_SIZES = {
  // Small text - disclaimers, fine print
  disclaimer: '0.75rem',    // 12px
  
  // Small body text - alerts, secondary information
  small: '0.875rem',        // 14px
  
  // Standard body text - default readable text
  body: '1.0rem',           // 16px
  
  // Subtitle/emphasized text - section headers, important labels
  subtitle: '1.125rem',     // 18px
  
  // Display numbers - monetary amounts, statistics
  displaySmall: '1.75rem',       // 28px
  
  // Page titles - main headings
  title: '2.25rem',         // 36px
  
  // Hero text - primary display amounts, hero headings
  hero: '2.50rem',           // 40px

  // Display text - Landing page headlines
  display: '3.0rem'           // 48px
};

/**
 * Usage example:
 * import { FONT_SIZES } from '../../../utils/typography';
 * 
 * <div style={{ fontSize: FONT_SIZES.body }}>
 *   Standard body text
 * </div>
 */
